import React from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { renderCheckBox, renderTextField, renderAutoCompleteSingleSelect, renderTextArea, renderAutoCompleteScheduling } from '../../../../../../components/reduxFields';
import { getBehaviorListDetails, saveBehavior, getMasterData } from './actions/behaviorActions';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../../../components/buttons';
import SmallLoader from '../../../../../../img/small-loader.gif';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../../../modules/AppConfig/actions';
import { MODULE } from './constants/ApiConstants';
import { displayCustomError } from '../../../../../../actions/utilAction';
import _ from 'lodash'

const validate = (values) => {
  const errors = {};
  if (!values.behaviorName) {
    errors.behaviorName = 'Please enter behavior name';
  }
  // if (!values.behaviorCategoryId) {
  //   errors.behaviorCategoryId = 'Please select behavior category';
  // }
  if (!values.recordingTypeId) {
    errors.recordingTypeId = 'Please select recroding Type';
  }

  if (!values.recordingType) {
    errors.recordingType = 'Please select recroding Type';
  }  
  return errors;
};

class BehaviorModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      recordingTypeIds: '0',
      recordingTypeName: this.props.behaviorObj ? this.props.behaviorObj.recordingTypeName : ''
    };
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleNewRequest = this.handleNewRequest.bind(this);
    this.handleNewRequestRecordingType = this.handleNewRequestRecordingType.bind(this);    
    this.debouncedCheckFieldDataExistence = _.debounce(this.checkFieldDataExistence.bind(this), 300);
  }

  componentWillMount() {
    if (this.props.behaviorId) {
      this.props.getBehaviorListDetails(this.props.behaviorId);
    }
    const masterData = { masterdata: 'MASTERBEHAVIORCATEGORY,MASTERRECORDINGTYPES,MASTERSTAFFACTIVEANDINACTIVE' };
    this.props.getMasterData(masterData);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };
  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function (evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  onSubmitHandler(formProps) {
    if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
      return null;
    }

    let behaviorRecordingTypes = [];
    if (!this.props.behaviorId) {    
      (formProps.recordingType || []).forEach((recordingTypeId) => {        
        behaviorRecordingTypes.push({           
            'recordingTypeId': recordingTypeId,
            'isDeleted': false,
          });
        
      });
      behaviorRecordingTypes = behaviorRecordingTypes.filter((obj) => obj.isDeleted === false);
    }

    let postData = {
      "id": this.props.behaviorId || 0,
      "patientId": this.props.patientId,
      "behaviorCategoryId": formProps.behaviorCategoryId,
      "recordingTypeId": formProps.recordingTypeId,
      "behaviorName": formProps.behaviorName || '',
      "goalName": formProps.goalName,
      "description": formProps.description || '',
      "function": formProps.function || '',
      "doNotZeroOut": formProps.doNotZeroOut || false,
      "excludeFromABCDataCollection" : formProps.excludeFromABCDataCollection || false,
      "isActive": formProps.isActive || false,
      "totalRecords": 0,
      'behaviorRecordingTypes': behaviorRecordingTypes,
    }

    // console.log(postData);
    this.props.saveBehavior(postData, this.props.patientId);
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.props.behaviorId || 0,
        'patientId': this.props.patientId ? parseInt(this.props.patientId) : 0,
        'additionalColmnId': this.props.behaviorId ? this.props.recordingTypeId : (this.state.recordingTypeIds.toString() ? this.state.recordingTypeIds.toString() : '0'),
      };
      this.setState({BehaviorName : value},()=>{
        this.props.checkFieldExistence(postData);
      });
      
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleNewRequestRecordingType(input, value) {
    input.onChange(value);   
    this.setState({recordingTypeIds : value},()=>{
      this.checkFieldDataExistenceForAddNewBehavior('Behavior name');
    });
  }

  checkFieldDataExistenceForAddNewBehavior = (labelName) => {
    if (this.state.BehaviorName != '') {
      let postData = {
        'labelName': labelName,
        'tableName': 'DCMASTER_BEHAVIORSREDUCTION_BEHAVIORNAME'.toUpperCase(),
        'value': this.state.BehaviorName,
        'colmnName': 'BEHAVIORNAME',
        'id': this.props.behaviorId || 0,
        'patientId': this.props.patientId ? parseInt(this.props.patientId) : 0,
        'additionalColmnId': this.state.recordingTypeIds.toString() ? this.state.recordingTypeIds.toString() : '0',
      };
      this.props.checkFieldExistence(postData);
    }
  };
  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
      <SubmitButtonModalDisabled label="Loading" /> :
      <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
      <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
      submitButton,
    ];
    return (
      <div>
        <Dialog
          className="custom_modal"
          title={this.props.behaviorId ? 'Edit Behavior' : 'Add Behavior'}
          modal={false}
          open={this.state.open}
          actions={actions}
          autoScrollBodyContent={true}
        >
          {this.renderLoading()}
          <div className="row">
            <div className="col-sm-12">
              <form className="readmin-form custom_form">
                <div className="row">
                  <div className='col-sm-12 require'>
                    <Field
                      name="behaviorName"
                      label="Behavior Name"
                      type="text"
                      onBlur={(input, value) => this.debouncedCheckFieldDataExistence(input, value, 'Behavior name')}
                      customError={displayCustomError('BEHAVIORNAME', this.props.fieldError)}        
                      maxLength="250"
                      component={renderTextField}
                      autoFocus="true"
                    />
                  </div>
                  <div className='col-sm-12 mt-30'>
                    <Field
                      name="behaviorCategoryId"
                      label="Behavior Category"
                      options={this.props.masterBehavior}
                      handleNewRequest={this.handleNewRequest}
                      component={renderAutoCompleteSingleSelect}
                    />
                  </div>
                  <div className='col-sm-12'>
                    <Field
                      name="goalName"
                      label="Goal Name (for reporting)"
                      type="text"
                      maxLength="250"
                      component={renderTextField}
                    />
                  </div>
                  <div className='col-sm-12 mt-10'>
                    <Field
                      name="function"
                      type="text"
                      maxLength="250"
                      label="Function"
                      // normalize ={isValidNameWithSpace}
                      component={renderTextField} />
                  </div>
                  <div className='col-sm-12 mt-10'>
                    <Field
                      name="description"
                      type="text"
                      maxLength="4000"
                      label="Definition"
                      // normalize ={isValidNameWithSpace}
                      component={renderTextArea} />
                  </div>
                  {/* {this.props.agencyName.toUpperCase() === VIP ? */}
                  <div className='col-sm-12 require mt-30'>
                    {this.props.behaviorId ?
                      <div className="row">
                          <div className="col-sm-6">
                            <Field
                                name="recordingTypeId"
                                label="Recording Type"
                                options={this.props.masterRecordingType}
                                handleNewRequest={this.handleNewRequest}
                                component={renderAutoCompleteSingleSelect}
                              />
                          </div>
                          <div className="col-sm-6">
                            <p className="recording_type">(Do not change recording type if you have started to take data. Changing recording type after data has been collected will delete previous data)</p>
                          </div>
                      </div>
                      : 
                      <div className="row">
                          <div className="col-sm-6">
                            <Field
                                name="recordingType"
                                label="Recording Type"
                                options={this.props.masterRecordingType}
                                handleNewRequest={this.handleNewRequestRecordingType}
                                component={renderAutoCompleteScheduling}
                              />
                          </div>
                          <div className="col-sm-6">
                            <p className="recording_type">(Do not change recording type if you have started to take data. Changing recording type after data has been collected will delete previous data)</p>
                          </div>
                      </div>}
                  </div>
                  {/* // :
                  // <div className='col-sm-12 require mt-30'>                  
                  //     <div className="row">
                  //         <div className="col-sm-6">
                  //           <Field
                  //               name="recordingTypeId"
                  //               label="Recording Type"
                  //               options={this.props.masterRecordingType}
                  //               handleNewRequest={this.handleNewRequest}
                  //               component={renderAutoCompleteSingleSelect}
                  //             />
                  //         </div>
                  //         <div className="col-sm-6">
                  //           <p className="recording_type">(Do not change recording type if you have started to take data. Changing recording type after data has been collected will delete previous data)</p>
                  //         </div>
                  //     </div>
                  // </div>} */}
                  {this.state.recordingTypeName.toString().toUpperCase() !== "PARTIAL INTERVAL" && this.state.recordingTypeName.toString().toUpperCase() !== "MOMENTARY TIME SAMPLE" ? 
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-6">
                              <Field className="mb0 custm_check"
                                name="doNotZeroOut"
                                label="Do not zero out"
                                component={renderCheckBox}
                              />
                            </div>
                            <div className="col-sm-6">
                              <p className="recording_type">('Do not Zero Out' functionality is not applicable to Momentary Time Sample and Partial Interval recording types)</p>
                            </div>
                        </div>
                    </div> : null}
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="excludeFromABCDataCollection"
                      label="Exclude From ABC Data Collection"
                      component={renderCheckBox}
                    />
                  </div>
                  <div className="col-sm-6">
                    <Field className="mt20 mb0 custm_check"
                      name="isActive"
                      label="Is Active"
                      component={renderCheckBox}
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
        </Dialog >
      </div >
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let initialValueData = {
    isActive: true,
  };
  if (ownProps.behaviorId && state.patient_behavior.behaviorDetail) {
    initialValueData = state.patient_behavior.behaviorDetail.data;
  }

  return {
    initialValues: initialValueData,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    behaviorDetail: state.patient_behavior.behaviorDetail,
    masterBehavior: state.patient_behavior.masterData && state.patient_behavior.masterData.masterBehaviorCategory,
    masterRecordingType: state.patient_behavior.masterData && state.patient_behavior.masterData.masterRecordingTypes,
    loading: state.patient_behavior.loading,
    recordingTypeId: initialValueData && initialValueData.recordingTypeId,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
};

BehaviorModal = reduxForm({
  form: 'BehaviorModalForm', // a unique identifier for this form
  validate,
  enableReinitialize: true,
})(BehaviorModal);

export default connect(mapStateToProps, { saveBehavior, getBehaviorListDetails, getMasterData, checkFieldExistence, clearFieldErrorArray })(BehaviorModal);



// WEBPACK FOOTER //
// ./src/modules/patients/components/DataCollection/BehaviorReductiom/Behavior/behavior_Modal.js